<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row v-else>
      <!-- 공지사항 -->
      <v-col cols="12" xl="6" md="6" xs="12">
        <stats-card
          header-color="primary"
          :contents="tabs.announcements.data"
          :prefix="tabs.announcements.prefix"
          :title="tabs.announcements.label"
          :icon="tabs.announcements.icon"
          :url-prefix="'https://www.iskal.org/notice/announcements'"
        ></stats-card>
      </v-col>

      <!-- 일정정보 -->
      <v-col cols="12" xl="6" md="6" xs="12">
        <stats-card
          header-color="primary"
          :contents="tabs.events.data"
          :prefix="tabs.events.prefix"
          :title="tabs.events.label"
          :icon="tabs.events.icon"
          url-prefix="https://www.iskal.org/conferences/post"
        ></stats-card>
      </v-col>

      <!-- 회원소식 -->
      <v-col cols="12" xl="6" md="6" xs="12">
        <stats-card
          header-color="primary"
          :contents="tabs.memberNews.data"
          :prefix="tabs.memberNews.prefix"
          :title="tabs.memberNews.label"
          :icon="tabs.memberNews.icon"
          url-prefix="https://www.iskal.org/notice/membernews"
        ></stats-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StatsCard from "@/components/cards/StatsCard.vue";
import { tabs } from "@/views/DashboardView/tabs";
import { boardApi, conferenceApi } from "@/api/api";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

export default {
  components: {
    StatsCard,
    LoadingSpinner,
  },
  data() {
    return {
      tabs: tabs,
      isLoading: false,
    };
  },
  methods: {
    /**
     * 공지사항 목록 조회 API 요청 메서드
     *
     * @param {number} [size = 1] - 페이징 사이즈
     * @param {number} [page = 5] - 페이징 페이지
     */
    async getAnnouncements(size, page) {
      this.getPosts(size, page, this.tabs.announcements);
    },

    /**
     * 회원소식 목록 조회 API 요청 메서드
     *
     * @param {number} [size = 1] - 페이징 사이즈
     * @param {number} [page = 5] - 페이징 페이지
     */
    async getMemberNews(size, page) {
      this.getPosts(size, page, this.tabs.memberNews);
    },

    /**
     * Board 타입 명세
     * @typedef {Object} Board
     * @property {string} label - 게시판 이름
     * @property {string} icon - 게시판 아이콘
     * @property {number} board_idx - 게시판 idx
     * @property {Object} data - 데이터
     */

    /**
     * 게시글 목록 조회 API 요청 메서드
     *
     * @param {number} [size = 1] - 페이징 사이즈
     * @param {number} [page = 5] - 페이징 페이지
     * @param {Board} board - 게시판 유형 (board_idx 필수)
     */
    async getPosts(size, page, board) {
      this.isLoading = true;
      const params = {
        board_idx: board.board_idx,
        page: page ? page : 1,
        size: size ? size : 5,
      };
      boardApi
        .getPosts(params)
        .then((res) => {
          board.data = res ? res.data.response.elements : [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    /**
     * 컨퍼런스 목록 조회 API 요청 메서드
     * @param {number} [size = 1] - 페이징 사이즈
     * @param {number} [page = 5] - 페이징 페이지
     */
    async getConferences(size, page) {
      this.isLoading = true;
      const params = {
        page: page ? page : 1,
        size: size ? size : 5,
      };
      conferenceApi
        .getConferences(params)
        .then((res) => {
          this.tabs.events.data = res ? res.data.response.elements : [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getAnnouncements();
    this.getMemberNews();
    this.getConferences();
  },
};
</script>
<style scoped></style>
